import type { VoiceManagementReadiness } from './ai-systems-api';

const READINESS_ERROR_MESSAGE =
  'Voice Agent management readiness could not be verified. The Add Voice Agent action remains unavailable.';

export function voiceManagementReadinessWarnings(
  readiness?: VoiceManagementReadiness,
  error?: unknown,
): string[] {
  if (error) return [READINESS_ERROR_MESSAGE];
  if (!readiness) return [];

  const warnings: string[] = [];
  if (!readiness.ready) {
    if (!readiness.enabled) {
      warnings.push('Cascade-local Voice Agent changes remain disabled. Add or edit Cascade agents from One Up Admin by selecting Cascade as the management client.');
    }

    const checks = readiness.checks;
    if (!checks) {
      warnings.push('Detailed Voice Agent readiness checks are unavailable from the current API response.');
      return warnings;
    }
    if (checks.providerAccountActive === false) {
      warnings.push('No active Vapi provider account is allocated to Cascade.');
    }
    if (checks.providerCredentialAvailable === false) {
      warnings.push('The Cascade Worker cannot resolve the Vapi API credential referenced by its provider account.');
    } else if (checks.providerReachable === false) {
      warnings.push('The configured Vapi account could not be validated.');
    } else if (checks.providerIdentityMatches === false) {
      warnings.push('The configured Vapi credential does not match the allocated provider organization.');
    }
    if (checks.entitlementConfigured === false) {
      warnings.push('Cascade does not have an active Voice Agent entitlement.');
    }
  } else if (readiness.liveCallReady === false) {
    warnings.push('Voice Agent management is ready, but the live-call connection is not fully verified.');

    const liveCallChecks = readiness.liveCallChecks;
    if (!liveCallChecks) {
      warnings.push('Detailed live-call checks are unavailable from the current API response.');
      return warnings;
    }
    if (liveCallChecks.webhookUrlConfigured === false) {
      warnings.push('The Vapi webhook URL is not configured.');
    }
    if (liveCallChecks.webhookAuthenticationConfigured === false) {
      warnings.push('The account-scoped Vapi webhook credential is not configured.');
    }
    if (liveCallChecks.phoneAllocated === false) {
      warnings.push('No Vapi phone number is allocated to Cascade.');
    }
    if (liveCallChecks.successfulWebhookReceived === false) {
      warnings.push('Cascade has not received a successfully processed Vapi webhook yet.');
    }
  }
  return warnings;
}
